export class NotificationTopic {
    id: number;
    name: string;
    displayName: string;

    constructor(value: Object = {}) {
        Object.assign(this, value);
    }
}


// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/notificationTopic.ts